import { createElement, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { bindMenus } from "./bindMenus.js";
import { bindStudioUtility } from "./StudioActionsPortal.js";
import { isLearnerChrome } from "./isLearnerChrome.js";
import { injectChromeStyles } from "./injectStyle.js";
import { renderHeader } from "./markup.js";
import { fetchAvatar, readChrome } from "./settings.js";
export { StudioActionsPortal, bindStudioUtility } from "./StudioActionsPortal.js";
import "./css.js";
import "./vendor/bsg-donate-drawer.js";

// Catalog / account / profile Header 8.1.0 mounts desktop XOR mobile
// via react-responsive (both at 769). One owner so we never paint two bars.
let headerOwner = null;

export function resetBsgHeaderOwner() {
  headerOwner = null;
}

export function BsgHeader() {
  injectChromeStyles();
  const tokenRef = useRef(null);
  if (tokenRef.current === null) {
    tokenRef.current = {};
  }
  if (headerOwner === null) {
    headerOwner = tokenRef.current;
  }
  const owns = headerOwner === tokenRef.current;
  const [chrome, setChrome] = useState(() => readChrome());
  const ref = useRef(null);

  useEffect(() => {
    if (headerOwner === null) {
      headerOwner = tokenRef.current;
    }
    return () => {
      if (headerOwner === tokenRef.current) {
        headerOwner = null;
      }
    };
  }, []);

  useEffect(() => {
    let cancelled = false;
    fetchAvatar(chrome).then((avatarUrl) => {
      if (cancelled || !avatarUrl) return;
      setChrome((current) => ({ ...current, user: { ...current.user, avatarUrl } }));
    });
    return () => {
      cancelled = true;
    };
  }, [chrome.user?.username, chrome.lmsBaseUrl]);

  useEffect(() => {
    const header = ref.current?.querySelector("[data-site-header]");
    if (!header) return undefined;
    const stopMenus = bindMenus(header);
    const stopStudio = bindStudioUtility(header);
    // Re-bind updates widgetSrc on the existing drawer. Do not unbind on
    // every chrome state change (avatar fetch) — that dropped listeners
    // and left a host without #give-lively-widget.
    window.bsgDonateDrawer?.bind({
      widgetSrc: chrome.donateWidgetSrc,
      donateUrl: chrome.donateUrl,
      heading: chrome.donateHeading,
      blurb: chrome.donateBlurb,
      learnMore: chrome.donateLearnMore,
      closeLabel: chrome.donateClose,
      donateNow: chrome.donateNow,
    });
    return () => {
      stopMenus?.();
      stopStudio?.();
    };
  }, [chrome]);

  useEffect(() => {
    return () => {
      window.bsgDonateDrawer?.unbind();
    };
  }, []);

  if (!isLearnerChrome() || !owns) return null;
  const tree = createElement("div", {
    className: "bsg-mfe-chrome",
    "data-bsg-header-root": "",
    ref,
    dangerouslySetInnerHTML: { __html: renderHeader(chrome) },
  });
  if (typeof document === "undefined" || typeof createPortal !== "function") {
    return tree;
  }
  // Escape leftover .desktop-header / PluginSlot overflow so position:fixed
  // is not clipped (catalog Hide+Insert nests us inside Header 8.1.0).
  return createPortal(tree, document.body);
}

export default BsgHeader;